export const removeNewLine = (string) => string.replace(/[\n\r]/g, "");
